module.exports = __webpack_public_path__ + "files/SPIADI2026 - EXP ADI - Tableau Exp-Onco (Version 2).fbdea804ba2dec926828ad9d1a6f1f46.pdf";